import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  CreditCard,
  KeyRound,
  Users,
  MessageSquare,
  Radio,
  Workflow,
  Bot,
  Brain,
  BarChart3,
  HardDrive,
  Archive,
  History,
  Bell,
  Activity,
  Shield,
  Settings,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export interface NavModule {
  id: string;
  label: string;
  path: string;
  icon: LucideIcon;
  group?: string;
}

export const NAV_GROUPS = [
  { id: 'commerce', label: 'Commerce' },
  { id: 'automation', label: 'Automation' },
  { id: 'crm', label: 'CRM & Support' },
  { id: 'intelligence', label: 'Intelligence' },
  { id: 'system', label: 'System' },
] as const;

export const NAV_MODULES: NavModule[] = [
  // Commerce
  { id: 'dashboard', label: 'Dashboard', path: '/', icon: LayoutDashboard, group: 'commerce' },
  { id: 'products', label: 'Products', path: '/products', icon: Package, group: 'commerce' },
  { id: 'orders', label: 'Orders', path: '/orders', icon: ShoppingCart, group: 'commerce' },
  { id: 'payments', label: 'Payments', path: '/payments', icon: CreditCard, group: 'commerce' },
  { id: 'vault', label: 'Vault', path: '/vault', icon: KeyRound, group: 'commerce' },
  { id: 'wallet', label: 'Wallet', path: '/wallet', icon: Wallet, group: 'commerce' },

  // Automation
  { id: 'workflows', label: 'Workflows', path: '/workflows', icon: Workflow, group: 'automation' },
  { id: 'bot', label: 'Bot Manager', path: '/bot', icon: Bot, group: 'automation' },
  { id: 'broadcasts', label: 'Broadcasts', path: '/broadcasts', icon: Radio, group: 'automation' },

  // CRM & Support
  { id: 'customers', label: 'Customers', path: '/customers', icon: Users, group: 'crm' },
  { id: 'tickets', label: 'Tickets', path: '/tickets', icon: MessageSquare, group: 'crm' },

  // Intelligence
  { id: 'ai', label: 'AI Studio', path: '/ai', icon: Brain, group: 'intelligence' },
  { id: 'analytics', label: 'Analytics', path: '/analytics', icon: BarChart3, group: 'intelligence' },
  { id: 'reports', label: 'Reports', path: '/reports', icon: Activity, group: 'intelligence' },

  // System
  { id: 'storage', label: 'Storage', path: '/storage', icon: HardDrive, group: 'system' },
  { id: 'backup', label: 'Backup', path: '/backup', icon: Archive, group: 'system' },
  { id: 'access-history', label: 'Access History', path: '/access-history', icon: History, group: 'system' },
  { id: 'notifications', label: 'Notifications', path: '/notifications', icon: Bell, group: 'system' },
  { id: 'monitoring', label: 'Monitoring', path: '/monitoring', icon: Activity, group: 'system' },
  { id: 'rbac', label: 'Team & Roles', path: '/team', icon: Shield, group: 'system' },
  { id: 'settings', label: 'Settings', path: '/settings', icon: Settings, group: 'system' },
];

export const QUICK_ACTIONS = [
  { id: 'new-product', label: 'New Product', action: () => {} },
  { id: 'new-order', label: 'New Order', action: () => {} },
  { id: 'new-broadcast', label: 'New Broadcast', action: () => {} },
  { id: 'new-ticket', label: 'New Ticket', action: () => {} },
  { id: 'toggle-theme', label: 'Toggle Theme', action: () => {} },
];
